/* eslint-disable import/prefer-default-export */
import PropTypes from 'prop-types';

const FiltersValues = PropTypes.objectOf(PropTypes.arrayOf(PropTypes.string));

export const QFiltersValue = PropTypes.shape({
  normal: PropTypes.objectOf(FiltersValues),
  related: PropTypes.objectOf(FiltersValues),
});
